export default __webpack_public_path__ + "static/media/icpc2.d6d35609.png";